import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle} from '@angular/material/dialog';
import {MatButton} from "@angular/material/button";

@Component({
    selector: 'app-shapefile-data-dialog',
    templateUrl: './shapefile-data-dialog.component.html',
    styleUrls: ['./shapefile-data-dialog.component.scss'],
    imports: [
        MatDialogTitle,
        MatDialogContent,
        MatDialogActions,
        MatButton
    ]
})
export class ShapefileDataDialogComponent {

    constructor(
        public dialogRef: MatDialogRef<ShapefileDataDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { features: any[], shapefileProperties: string[] }
    ) {
    }

    onClose(): void {
        this.dialogRef.close();
    }
}
